import { Skeleton } from "../../../../../shared/components/ui/skeleton";

type AvailableBalanceProps = {
  amountDisplay?: string;
  currencyLabel?: string;
  isLoading: boolean;
  errorMessage?: string;
};

export default function AvailableBalance({
  amountDisplay,
  currencyLabel,
  isLoading,
  errorMessage,
}: Readonly<AvailableBalanceProps>) {
  if (isLoading) {
    return (
      <div className="flex flex-col gap-2">
        <Skeleton className="h-8 w-32 bg-white/10" />
        <p className="text-label-dark text-xs">Available Balance</p>
      </div>
    );
  }

  if (errorMessage) {
    return (
      <div className="flex flex-col gap-2">
        <p className="text-sm text-red-400 max-w-[220px]">{errorMessage}</p>
        <p className="text-label-dark text-xs">Available Balance</p>
      </div>
    );
  }

  if (!amountDisplay) {
    return (
      <div className="flex flex-col gap-2">
        <p className="text-sm text-white/60">No balances yet</p>
        <p className="text-label-dark text-xs">Available Balance</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center">
        <div className="text-2xl text-white font-semibold">{amountDisplay}</div>
        {currencyLabel ? (
          <div className="ml-2 text-sm uppercase">{currencyLabel}</div>
        ) : null}
        {/* <div className="ml-2 mb-1">
          <SecondaryIcon icon={Icons.ChevronDown({ width: 10, height: 10 })} />
        </div> */}
      </div>
      <p className="text-label-dark text-xs">Available Balance</p>
    </div>
  );
}
